export default "__VITE_ASSET__B0ybm2Vx__"